export const DISCOVER_SECTION_KEYS = [
  'discover.sections.approachValues',
  'discover.sections.objectives',
  'discover.sections.team',
  'discover.sections.interface',
  'discover.sections.corpus',
  'discover.sections.architecture',
  'discover.sections.practice',
] as const

export const APPROACH_CARDS = [
  {
    icon: '/Insurance.svg',
    cardBg: 'bg-discover-card-cream',
    iconBg: 'bg-discover-icon-amber',
    titleKey: 'discover.approachCards.card1.title',
    descriptionKey: 'discover.approachCards.card1.description',
    useTrans: true,
  },
  {
    icon: '/Increase.svg',
    cardBg: 'bg-discover-card-cream',
    iconBg: 'bg-discover-icon-green',
    titleKey: 'discover.approachCards.card2.title',
    descriptionKey: 'discover.approachCards.card2.description',
    useTrans: false,
  },
  {
    icon: '/Coconstruction.svg',
    cardBg: 'bg-discover-card-mint',
    iconBg: 'bg-discover-icon-teal',
    titleKey: 'discover.approachCards.card3.title',
    descriptionKey: 'discover.approachCards.card3.description',
    useTrans: false,
  },
  {
    icon: '/Transparence.svg',
    cardBg: 'bg-discover-card-pink',
    iconBg: 'bg-discover-icon-red',
    titleKey: 'discover.approachCards.card4.title',
    descriptionKey: 'discover.approachCards.card4.description',
    useTrans: false,
  },
  {
    icon: '/Confidential.svg',
    cardBg: 'bg-discover-card-lavender',
    iconBg: 'bg-discover-icon-purple',
    titleKey: 'discover.approachCards.card5.title',
    descriptionKey: 'discover.approachCards.card5.description',
    useTrans: false,
  },
  {
    icon: '/Independant.svg',
    cardBg: 'bg-discover-card-magenta-light',
    iconBg: 'bg-discover-icon-violet',
    titleKey: 'discover.approachCards.card6.title',
    descriptionKey: 'discover.approachCards.card6.description',
    useTrans: false,
  },
  {
    icon: '/Finance.svg',
    cardBg: 'bg-discover-card-rose',
    iconBg: 'bg-discover-icon-magenta',
    titleKey: 'discover.approachCards.card7.title',
    descriptionKey: 'discover.approachCards.card7.description',
    useTrans: false,
  },
] as const

export const OBJECTIVES_CARDS = [
  {
    icon: '/Access.svg',
    cardBg: 'bg-discover-card-objectives-1',
    iconBg: 'bg-discover-icon-objectives-red',
    descriptionKey: 'discover.objectivesCards.card1.description',
    useTrans: true,
  },
  {
    icon: '/Actor.svg',
    cardBg: 'bg-discover-card-objectives-2',
    iconBg: 'bg-discover-icon-objectives-blue',
    descriptionKey: 'discover.objectivesCards.card2.description',
    useTrans: true,
  },
] as const

export const INTERFACE_CARDS = [
  {
    icon: '/ReadAloud.svg',
    cardBg: 'bg-discover-card-cream',
    iconBg: 'bg-discover-icon-amber',
    titleKey: 'discover.sections.interfaceCards.card1.title',
    descriptionKey: 'discover.sections.interfaceCards.card1.description',
  },
  {
    icon: '/Content.svg',
    cardBg: 'bg-discover-card-interface-2',
    iconBg: 'bg-discover-icon-green',
    titleKey: 'discover.sections.interfaceCards.card2.title',
    descriptionKey: 'discover.sections.interfaceCards.card2.description',
  },
  {
    icon: '/Access.svg',
    cardBg: 'bg-discover-card-interface-3',
    iconBg: 'bg-discover-icon-teal',
    titleKey: 'discover.sections.interfaceCards.card3.title',
    descriptionKey: 'discover.sections.interfaceCards.card3.description',
  },
] as const

export const ARCHITECTURE_CARDS = [
  {
    titleKey: 'discover.sections.architectureCards.card1.title',
    descriptionKey: 'discover.sections.architectureCards.card1.description',
    useTrans: false,
  },
  {
    titleKey: 'discover.sections.architectureCards.card2.title',
    descriptionKey: 'discover.sections.architectureCards.card2.description',
    useTrans: true,
  },
  {
    titleKey: 'discover.sections.architectureCards.card3.title',
    descriptionKey: 'discover.sections.architectureCards.card3.description',
    useTrans: false,
  },
] as const
